import { render, staticRenderFns } from "./SafeAreaTop.vue?vue&type=template&id=381d5cc6&scoped=true"
import script from "./SafeAreaTop.vue?vue&type=script&lang=js"
export * from "./SafeAreaTop.vue?vue&type=script&lang=js"
import style0 from "./SafeAreaTop.vue?vue&type=style&index=0&id=381d5cc6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381d5cc6",
  null
  
)

export default component.exports